import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M32.117 8.883A28.3 28.3 0 0 0 25 6.667a.15.15 0 0 0-.117.05c-.3.55-.65 1.266-.883 1.816-2.652-.4-5.348-.4-8 0a17 17 0 0 0-.9-1.816c-.017-.034-.067-.05-.117-.05a28.5 28.5 0 0 0-7.116 2.216c-.017 0-.034.017-.05.034C3.283 15.7 2.033 22.3 2.65 28.833c0 .034.017.067.05.084 3 2.2 5.883 3.533 8.733 4.416.05.017.1 0 .117-.033a21.5 21.5 0 0 0 1.783-2.9c.034-.067 0-.133-.066-.15-.95-.367-1.85-.8-2.734-1.3-.066-.033-.066-.133-.016-.183.183-.134.366-.284.55-.417a.1.1 0 0 1 .116-.017c5.734 2.617 11.917 2.617 17.584 0a.1.1 0 0 1 .116.017c.184.15.367.283.55.433.067.05.067.15-.016.184-.867.516-1.784.933-2.734 1.3-.066.016-.083.1-.066.15a25.5 25.5 0 0 0 1.783 2.9c.05.016.1.033.15.016 2.867-.883 5.75-2.216 8.75-4.416a.09.09 0 0 0 .05-.084c.733-7.55-1.217-14.1-5.167-19.916-.016-.017-.033-.034-.066-.034M14.2 24.85c-1.717 0-3.15-1.583-3.15-3.533s1.4-3.534 3.15-3.534c1.767 0 3.167 1.6 3.15 3.534 0 1.95-1.4 3.533-3.15 3.533m11.617 0c-1.717 0-3.15-1.583-3.15-3.533s1.4-3.534 3.15-3.534c1.766 0 3.166 1.6 3.15 3.534 0 1.95-1.384 3.533-3.15 3.533"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }